import posthog from 'posthog-js'
import 'posthog-js/dist/surveys'

let initialized = false

const buildPersonProperties = ({ userId, email = '' }) => ({
  email,
  usu_id: userId ? String(userId) : undefined,
  platform: 'web',
})

const identifyUser = (ph, { userId = '', email = '' }) => {
  if (!email) return

  const currentDistinctId = ph.get_distinct_id()

  if (currentDistinctId && currentDistinctId !== email) {
    ph.alias(email)
  }

  ph.identify(email, buildPersonProperties({ userId, email }))
}

const displayMatchingSurveys = () => {
  if (!initialized || typeof posthog.getActiveMatchingSurveys !== 'function') return

  posthog.getActiveMatchingSurveys((surveys) => {
    if (!surveys || !surveys.length) return

    surveys.forEach((survey) => {
      posthog.displaySurvey(survey.id)
    })
  }, true)
}

const scheduleSurveyEvaluation = () => {
  if (!initialized) return

  if (typeof posthog.getActiveMatchingSurveys === 'function') {
    displayMatchingSurveys()
    return
  }

  posthog.onSurveysLoaded(displayMatchingSurveys)
}

export const init = ({ userId = '', email = '' } = {}) => {
  const apiKey = process.env.REACT_APP_POSTHOG_API_KEY
  const apiHost = process.env.REACT_APP_POSTHOG_HOST

  if (!apiKey || initialized) return

  initialized = true

  posthog.init(apiKey, {
    api_host: apiHost,
    person_profiles: 'identified_only',
    autocapture: false,
    capture_pageview: 'history_change',
    capture_pageleave: false,
    capture_performance: false,
    bootstrap: email
      ? {
          distinctID: email,
          isIdentifiedID: true,
        }
      : undefined,
    loaded: (ph) => {
      identifyUser(ph, { userId, email })
      scheduleSurveyEvaluation()
    },
  })
}

export const identify = ({ userId = '', email = '' }) => {
  if (!initialized || !email) return

  identifyUser(posthog, { userId, email })
  scheduleSurveyEvaluation()
}

export const reset = () => {
  if (!initialized) return
  posthog.reset()
}

export const onAuthenticatedRouteChange = (pathname) => {
  if (!initialized || pathname === '/login') return
  scheduleSurveyEvaluation()
}
